module.exports = __webpack_public_path__ + "img/google-pay.fc25f36a.svg";